/**
 * Fuentes embebidas en los PDF (equivalentes abiertos de Helvetica/Times/Courier),
 * servidas también al navegador para que el editor de plantillas se vea igual
 * que el PDF final: Carlito=Calibri, Tinos=Times New Roman, Cousine=Courier New.
 *
 * Se inyecta como <style> en runtime (en vez de un .css importado) para que las
 * rutas absolutas /api/fonts/... apunten al backend tal cual, sin que webpack
 * intente resolverlas como módulos locales al compilar.
 */
const FONT_FACE_CSS = `
@font-face { font-family: 'Carlito'; src: url('/api/fonts/carlito/Carlito-Regular.ttf') format('truetype'); font-weight: normal; font-style: normal; }
@font-face { font-family: 'Carlito'; src: url('/api/fonts/carlito/Carlito-Bold.ttf') format('truetype'); font-weight: bold; font-style: normal; }
@font-face { font-family: 'Carlito'; src: url('/api/fonts/carlito/Carlito-Italic.ttf') format('truetype'); font-weight: normal; font-style: italic; }
@font-face { font-family: 'Carlito'; src: url('/api/fonts/carlito/Carlito-BoldItalic.ttf') format('truetype'); font-weight: bold; font-style: italic; }

@font-face { font-family: 'Tinos'; src: url('/api/fonts/tinos/Tinos-Regular.ttf') format('truetype'); font-weight: normal; font-style: normal; }
@font-face { font-family: 'Tinos'; src: url('/api/fonts/tinos/Tinos-Bold.ttf') format('truetype'); font-weight: bold; font-style: normal; }
@font-face { font-family: 'Tinos'; src: url('/api/fonts/tinos/Tinos-Italic.ttf') format('truetype'); font-weight: normal; font-style: italic; }
@font-face { font-family: 'Tinos'; src: url('/api/fonts/tinos/Tinos-BoldItalic.ttf') format('truetype'); font-weight: bold; font-style: italic; }

@font-face { font-family: 'Cousine'; src: url('/api/fonts/cousine/Cousine-Regular.ttf') format('truetype'); font-weight: normal; font-style: normal; }
@font-face { font-family: 'Cousine'; src: url('/api/fonts/cousine/Cousine-Bold.ttf') format('truetype'); font-weight: bold; font-style: normal; }
@font-face { font-family: 'Cousine'; src: url('/api/fonts/cousine/Cousine-Italic.ttf') format('truetype'); font-weight: normal; font-style: italic; }
@font-face { font-family: 'Cousine'; src: url('/api/fonts/cousine/Cousine-BoldItalic.ttf') format('truetype'); font-weight: bold; font-style: italic; }
`;

let injected = false;
export function ensurePdfFontsLoaded() {
  if (injected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.setAttribute('data-pdf-fonts', 'true');
  style.textContent = FONT_FACE_CSS;
  document.head.appendChild(style);
  injected = true;
}
